import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const SplintType = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Splint Type Used</InputLabel>
      <Select
        value={moduleValues?.['Splint Type Used'] ?? ''}
        label='Splint Type Used'
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Splint Type Used']: e.target.value,
          }))
        }
      >
        <MenuItem value="Rigid Splint">Rigid Splint</MenuItem>
        <MenuItem value="SAM Splint">SAM Splint</MenuItem>
        <MenuItem value="Vacuum Splint">Vacuum Splint</MenuItem>
        <MenuItem value="Traction Splint">Traction Splint</MenuItem>
        <MenuItem value="Air Splint">Air Splint</MenuItem>
        <MenuItem value="Improvised Splint">Improvised Splint</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default SplintType
